const { imsRoutes } = require("../../constants/Routes");
const axios = require("axios");

export const getImsJson = async (credNo) => {
	try {
		let imsJson = await axios.get(`${imsRoutes.ims}/${credNo}`);
		return imsJson.data;
	} catch (err) {
		return {};
	}
};

export const downloadBakedPng = async (credNo) => {
	try {
		let res = await fetch(`${imsRoutes.imsImage}/${credNo}`);
		const blob = await res.blob();
		const newBlob = new Blob([blob]);
		const blobUrl = window.URL.createObjectURL(newBlob);

		const link = document.createElement("a");
		link.href = blobUrl;
		link.setAttribute("download", `${credNo}.png`);
		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);

		window.URL.revokeObjectURL(blob);
	} catch (err) {
		console.log(err);
		throw err;
	}
};
